import { render } from "./AppToast.vue?vue&type=template&id=1867bb40"
import script from "./AppToast.vue?vue&type=script&lang=js"
export * from "./AppToast.vue?vue&type=script&lang=js"

import "./AppToast.vue?vue&type=style&index=0&id=1867bb40&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__